// components/TabSwitcher.jsx
import { Button, Space } from "antd"
import "../style/TabSwitcher.css"

const TabSwitcher = () => {
     const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="tab-switcher-wrapper">
      <Space size="large">
        <Button className="custom-tab-button" onClick={() => handleScroll("sim-section")}>
          SIM số đẹp
        </Button>
        <Button className="custom-tab-button" onClick={() => handleScroll("package-section")}>
          Gói cước khủng
        </Button>
      </Space>
    </div>
  )
}
export default TabSwitcher
